import * as React from 'react';
import {createContext, useContext, useEffect, useState} from 'react';
import {Editor} from '@tiptap/react';

export const TiptapEditorContext = createContext<Editor | null>(null);

export const TiptapEditorProvider = ({children, value}: TiptapEditorProviderProps) => (
    <TiptapEditorContext.Provider value={value}>{children}</TiptapEditorContext.Provider>
);

export type TiptapEditorProviderProps = {
    children: React.ReactNode;
    value: Editor | null;
};

export const useTiptapEditor = () => {
    const [ready, setReady] = useState(false);
    const editor = useContext(TiptapEditorContext);

    useEffect(() => {
        const onReady = () => {
            setReady(true);
        };

        if (editor != null) {
            // This ensure support for hot reload
            setReady(editor.isEditable);

            editor.on('create', onReady);
        }

        return () => {
            if (editor != null) {
                editor.off('create', onReady);
            }
        };
    }, [editor]);

    if (ready) {
        return editor;
    }
    return null;
};
